import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'myabvv-message-box',
    standalone: true,
    templateUrl: './message-box.component.html',
    styleUrls: ['message-box-component.css'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageBoxComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);

  message: string;
  btnOkText: string;
  btnCancelText: string;
  messageParams?: object;

  ngOnInit() {
    this.message = this.config.data.message;
    this.btnCancelText = this.config.data.btnCancelText;
    this.btnOkText = this.config.data.btnOkText;
    this.messageParams = this.config.data.messageParams;
  }

  public decline() {
    this.ref.close(false);
  }

  public accept() {
    this.ref.close(false);
  }
}

